import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { PageLayout } from '@src/common/PageLayout';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { UHCProviderLink } from '@src/common/UHCProviderLink';
import { useUser } from '@src/state/user';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';

const Layout = styled('div', {
  margin: 'auto',
  borderRadius: '3px',
  border: '1px solid rgb(219, 219, 219)',
  background: '$white',
  flex: 1,
  paddingLeft: 20,
  display: 'flex',
  flexDirection: 'column',
  width: '80%',
  alignSelf: 'center',
  marginTop: '5%',
});

const LayoutHeader = styled('h2', {
  fontSize: '24px',
  fontWeight: 600,
  color: '$primary1',
  width: '80%',
});

const LayoutInstruction = styled('p', {
  fontWeight: 500,
  paddingTop: '10px',
});

const Contact = styled('text', {
  fontFamily: '$primary',
  color: '#196ECF',
});

const LayoutIcon = styled('div', {
  padding: '10px',
});

const pageLayoutStyle = {
  maxWidth: '800px',
};

export const ErrorComponent = (props) => {
  const { isAPIMarketPlaceUser } = useUser.state();

  return (
    <LoadingOverlay>
      <PageLayout style={pageLayoutStyle}>
        <Flex>
          <Layout>
            <LayoutIcon>
              <IconBrand
                icon="alert"
                style={{
                  height: '70px',
                  width: '70px',
                  marginTop: '15px',
                  marginBottom: '20px',
                }}
                variant="twotone"
              />
            </LayoutIcon>
            <LayoutHeader>
              We're sorry! Our system is not responding.
            </LayoutHeader>
            <LayoutInstruction>
              {isAPIMarketPlaceUser ? (
                <React.Fragment>
                  Please email us at <Contact>apiconsultant@uhc.com</Contact>{' '}
                  for additional assistance.
                </React.Fragment>
              ) : (
                <React.Fragment>
                  For additional assistance, please contact our UnitedHealthcare
                  Web Support team by clicking the chat icon on the bottom right
                  of this screen. Support is also available by calling
                  866-842-3278, option 1.
                </React.Fragment>
              )}
            </LayoutInstruction>
          </Layout>
          <UHCProviderLink
            style={{
              margin: 'auto',
              width: '80%',
              display: 'inline-flex',
              marginTop: '20px',
              flexDirection: 'row',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          />
        </Flex>
      </PageLayout>
    </LoadingOverlay>
  );
};
